import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';
import _ from 'lodash';

import KeystrokeInputableText from '@/components/keystrokeInputableText/KeystrokeInputableText.vue';

import { InputableTextMixin } from '@/components/inputableText/InputableText';

import { PlbscfInputableTextId } from '@/entries/user/mixins/PlbscfKeystrokeInputableTextMixin';
import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';
import 計画三表TableMixin from '@/entries/user/mixins/計画三表TableMixin';

import AbstractPlbscfService, {
  PlbscfYearItem,
  YearItemType,
  科目別計画明細_CONFIG_COUNT,
} from '@/classes/service/AbstractPlbscfService';
import 決算期Utility, { 決算期TableHeader } from '@/classes/common/決算期Utility';
import { E計画表示モード } from '@/openapi/enum';

export default mixins(InputableTextMixin, 計画書Mixin, 計画三表TableMixin).extend({
  name: 'C科目別TableRow',

  props: {
    yearItems: {
      type: Array as PropType<PlbscfYearItem[]>,
      required: true,
    },
    isGray: {
      type: Boolean,
      required: true,
    },
    canEdit: {
      type: Boolean,
      required: true,
    },
    listItemIndex: {
      type: Number,
      required: true,
    },
    map: {
      type: Array as PropType<PlbscfInputableTextId[][]>,
      required: true,
    },
    cssClass: {
      type: String,
      default: '',
    },
    // monthlyValues の index が 0～readonlyMonthIndex であるものを入力不可とする
    // null ならば、全てのindexが入力可能
    readonlyMonthIndex: {
      type: Number,
      default: null,
    },
    header: {
      type: Array as PropType<決算期TableHeader[]>,
      default: null,
    },
  },

  components: {
    KeystrokeInputableText,
  },

  computed: {
    disableMonths(): boolean[] {
      return this.header?.filter((h) => h.month).map((h) => h.disabled!);
    },
  },

  methods: {
    getYearlyValue(yearItem: PlbscfYearItem): number {
      const value = AbstractPlbscfService.getOptionValueIfExistOrDBValue(
        yearItem,
        undefined,
        false,
        yearItem.type !== YearItemType.readonly,
        yearItem.item.科目別計画明細No === 科目別計画明細_CONFIG_COUNT
      );
      return value === undefined ? 0 : value;
    },
    isEditableMonth(monthIndex: number): boolean {
      return this.canEdit && (this.readonlyMonthIndex === null || monthIndex > this.readonlyMonthIndex);
    },
    isDisabled(monthIndex: number): boolean {
      return this.disableMonths[monthIndex];
    },
    isYearConfig(year: number): boolean {
      return this.計画書.c計画表示モード === E計画表示モード.年次計画 && 決算期Utility.diffYearFrom0期(year, true) > 0;
    },
  },
});
